// @halo/web-types — shared TypeScript interfaces for frontend apps
export * from './analytics.js';
export * from './halo-v2.js';
export * from './reports.js';
export * from './calendar.js';
export var RoleType;
(function (RoleType) {
    RoleType[RoleType["ADMIN"] = 0] = "ADMIN";
    RoleType[RoleType["USER"] = 1] = "USER";
})(RoleType || (RoleType = {}));
export var StoreType;
(function (StoreType) {
    StoreType[StoreType["IKAS"] = 0] = "IKAS";
    StoreType[StoreType["SHOPIFY"] = 1] = "SHOPIFY";
    StoreType[StoreType["OTHER"] = 2] = "OTHER";
    StoreType[StoreType["DEFAULT"] = 3] = "DEFAULT";
})(StoreType || (StoreType = {}));
export var PermissionType;
(function (PermissionType) {
    PermissionType[PermissionType["DEFAULT"] = 0] = "DEFAULT";
    PermissionType[PermissionType["OWNER"] = 1] = "OWNER";
    PermissionType[PermissionType["COLLABORATOR"] = 2] = "COLLABORATOR";
})(PermissionType || (PermissionType = {}));
//# sourceMappingURL=index.js.map